import React, { useEffect, useState } from "react";
import {
  FaCrown,
  FaDownload,
  FaNetworkWired,
  FaWifi,
  FaStore,
} from "react-icons/fa";
import { getRequest } from "../helpers/api.helper";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const MembershipDetails: React.FC = () => {
  const [membership, setMembership] = useState<any | null>(null);
  const [loading, setLoading] = useState(true);
  const [pkg, setPkg] = useState<any | null>(null);
  const navigate = useNavigate();


  useEffect(() => {
    const getMembershipDetails = async () => {
      try {
        const res = await getRequest("/user/membership");
        if (res.success) {
          setMembership(res.data);
          setPkg(res.data?.package);
        } else
          toast.error(res.message || "Unable to fetch membership details.");
      } catch (err) {
        console.error(err);
        toast.error("Server error while fetching membership details.");
      } finally {
        setLoading(false);
      }
    };
    getMembershipDetails();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-gray-600">
        Loading membership details...
      </div>
    );
  }

  if (!membership) {
    return (
      <div className="min-h-screen flex items-center justify-center text-gray-600">
        No membership information found.
      </div>
    );
  }

  const { paymentStatus } = membership;
  const isPaid = paymentStatus === "paid";

  // pick icon based on service type
  const getServiceIcon = () => {
    if (pkg.service === "only_online")
      return <FaWifi className="text-blue-500" />;
    if (pkg.service === "only_offline")
      return <FaStore className="text-green-600" />;
    if (pkg.service === "online_offline")
      return <FaNetworkWired className="text-purple-600" />;
    return null;
  };

  const getServiceLabel = () => {
    switch (pkg.service) {
      case "only_online":
        return "Online Service";
      case "only_offline":
        return "Offline Service";
      case "online_offline":
        return "Online + Offline Service";
      default:
        return "Free Service";
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 pt-20 pb-10 px-4">
      <div className="max-w-md mx-auto bg-white shadow-md rounded-xl p-6 border border-gray-200 text-gray-700">
        {/* Header */}
        <div className="flex items-center justify-center mb-5">
          <FaCrown
            className={`text-3xl mr-3 ${
              isPaid ? "text-yellow-500" : "text-gray-400"
            }`}
          />
          <h2 className="text-xl font-bold text-gray-800">My Membership</h2>
        </div>

        {/* Summary */}
        <div className="space-y-3 text-sm">
          <p>
            <strong>Status:</strong>{" "}
            <span
              className={`font-semibold ${
                isPaid ? "text-green-600" : "text-red-600"
              }`}
            >
              {isPaid ? "Paid" : "Free"}
            </span>
          </p>
          <p>
            <strong>Service Type:</strong>{" "}
            <span className="inline-flex items-center gap-2">
              {getServiceIcon()}
              {getServiceLabel()}
            </span>
          </p>
          <p>
            <strong>Visible Contacts:</strong> {pkg.visibleContactNumbers || 0}
          </p>
          <p>
            <strong>Validity:</strong>{" "}
            {pkg.validityDays ? `${pkg.validityDays} days` : "N/A"}
          </p>
          <p>
            <strong>Registration Fees:</strong> ₹{pkg.registrationFees || 0}
          </p>
          <p>
            <strong>Goodwill Amount:</strong> ₹{pkg.goodwillAmount || 0}
          </p>
          <p>
            <strong>Total Paid:</strong> ₹{pkg.payingAmount || 0}
          </p>
        </div>

        {/* Invoice + Renew Buttons */}
        <div className="mt-8 flex flex-col gap-3">
          {/* {isPaid && hasPackage && (
            <button
              onClick={() => window.open("/membership/invoice", "_blank")}
              className="w-full bg-gradient-to-r from-purple-600 to-pink-600 text-white py-2.5 rounded-full font-medium flex items-center justify-center gap-2 hover:opacity-90 transition"
            >
              <FaDownload /> Download Invoice
            </button>
          )} */}

          <button
            onClick={() => navigate("/admin/membership/plans")}
            className="w-full bg-gradient-to-r from-orange-500 to-red-500 text-white py-2.5 rounded-full font-medium hover:opacity-90 transition"
          >
            {isPaid ? "Upgrade Plan" : "Get Premium Plan"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MembershipDetails;
